import { useState } from "react";
import { EmployeeProxy } from "@me-team/host/main/graphql/types";

interface EmployeeHookResult {
    showSalaryModal: boolean;
    setShowSalaryModal: (arg: boolean) => void;
    selectedEmployee: EmployeeProxy | null;
    deleteModalShow: boolean;
    setDeleteModalShow: (arg: boolean) => void;
    showBookingSettingsModal: boolean;
    handleShowSalaryModal: (employee: EmployeeProxy) => void;
    deleteEmployee: (employee: EmployeeProxy) => void;
    handleToggleBookingSettingsModal: () => void;
    bookingSettings: (employee: EmployeeProxy) => void;
    tooltipResetKey: number;
}

export const useEmployee = (): EmployeeHookResult => {
    const [showSalaryModal, setShowSalaryModal] = useState<boolean>(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [deleteModalShow, setDeleteModalShow] = useState<boolean>(false);
    const [showBookingSettingsModal, setShowBookingSettingsModal] = useState<boolean>(false);
    const [tooltipResetKey, setTooltipResetKey] = useState<number>(0);

    const handleToggleBookingSettingsModal = () => {
        setShowBookingSettingsModal((prev) => {
            const next = !prev;
            if (!next) {
                setTooltipResetKey((prevKey) => prevKey + 1);
            }
            return next;
        });
    };

    const handleShowSalaryModal = (employee: EmployeeProxy) => {
        setSelectedEmployee(employee);
        setShowSalaryModal(true);
    };

    const deleteEmployee = (employee: EmployeeProxy) => {
        setSelectedEmployee(employee);
        setDeleteModalShow(true);
    };

    const bookingSettings = (employee: EmployeeProxy) => {
        setSelectedEmployee(employee);
        setShowBookingSettingsModal(true);
    };

    return {
        showSalaryModal,
        setShowSalaryModal,
        selectedEmployee,
        deleteModalShow,
        setDeleteModalShow,
        showBookingSettingsModal,
        handleShowSalaryModal,
        deleteEmployee,
        handleToggleBookingSettingsModal,
        bookingSettings,
        tooltipResetKey,
    };
};
